/**
 * お知らせ設定ページ用のスクリプト
 */
 if (is_route('preference.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        preference_event_set();
        preference_setting_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.preference_event_set = function() {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], false, function(results) {
            preference_setting_event_set();
        });
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });
}
/**
 * 設定モーダル表示時のイベント設定
 */
 window.preference_setting_event_set = function () {

}